const data = [
    
{
    id: 1,
    isCharged: true,
    name: "Atributo",
    lastDate: "09/09/2023",
    pictogramQty: 2,
    incomplete: true,
    pictograms: [
        {
            name: "10M2",
            img: "https://i.imgur.com/cRZ1tbD.png"
        },

        {
            name: "30M2"
        }
    ]
}, {
    id:2,
    isCharged: false,
    name: "Medida",
    lastDate: "09/09/2023",
    pictogramQty: 1,
    incomplete: false,
    pictograms: [ {
        name: "10M²",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    
    ]
},

{
    id:3,
    isCharged: false,
    name: "Área",
    lastDate: "09/09/2023",
    pictogramQty: 1,
    incomplete: false,
    pictograms: [ {
        name: "20M²",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    
    ]
},

{
    id:4,
    isCharged: false,
    name: "Marca",
    lastDate: "09/09/2023",
    pictogramQty: 1,
    incomplete: false,
    pictograms: [ {
        name: "220V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    
    ]
},


{
    id:5,
    isCharged: false,
    name: "Tonalidade",
    lastDate: "09/09/2023",
    pictogramQty: 1,
    incomplete: false,
    pictograms: [ {
        name: "220V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    
    ]
},


{
    id:10,
    isCharged: false,
    name: "Tensão Elétrica",
    lastDate: "09/09/2023",
    pictogramQty: 18,
    incomplete: false,
    pictograms: [ {
        name: "220V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "221V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "222V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "223V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "224V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "225V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "226V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "227V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "228V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "229V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "230V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "231V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },

    {
        name: "232V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "233V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "234V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },

    {
        name: "235V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "236V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    {
        name: "237V",
        img: "https://i.imgur.com/cRZ1tbD.png"
    },
    
    ]
},


]

export default data